import React, { Component } from 'react';

class FontAwesome extends Component {
  render() {
    return (
      <div className="animated fadeIn">
  <div className="card" id="new">
    <div className="card-header">20 New Icons in 4.5</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bluetooth fa-lg mt-4"></i><br/>bluetooth
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bluetooth-b fa-lg mt-4"></i><br/>bluetooth-b
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-codiepie fa-lg mt-4"></i><br/>codiepie
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-credit-card-alt fa-lg mt-4"></i><br/>credit-card-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-edge fa-lg mt-4"></i><br/>edge
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fort-awesome fa-lg mt-4"></i><br/>fort-awesome
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hashtag fa-lg mt-4"></i><br/>hashtag
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mixcloud fa-lg mt-4"></i><br/>mixcloud
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-modx fa-lg mt-4"></i><br/>modx
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pause-circle fa-lg mt-4"></i><br/>pause-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pause-circle-o fa-lg mt-4"></i><br/>pause-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-percent fa-lg mt-4"></i><br/>percent
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-product-hunt fa-lg mt-4"></i><br/>product-hunt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reddit-alien fa-lg mt-4"></i><br/>reddit-alien
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-scribd fa-lg mt-4"></i><br/>scribd
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shopping-bag fa-lg mt-4"></i><br/>shopping-bag
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shopping-basket fa-lg mt-4"></i><br/>shopping-basket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stop-circle fa-lg mt-4"></i><br/>stop-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stop-circle-o fa-lg mt-4"></i><br/>stop-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-usb fa-lg mt-4"></i><br/>usb
        </div>

      </div>

    </div>
  </div>

  <div className="card" id="web-application">
    <div className="card-header">Web Application Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-adjust fa-lg mt-4"></i><br/>adjust
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-anchor fa-lg mt-4"></i><br/>anchor
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-archive fa-lg mt-4"></i><br/>archive
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-area-chart fa-lg mt-4"></i><br/>area-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows fa-lg mt-4"></i><br/>arrows
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows-h fa-lg mt-4"></i><br/>arrows-h
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows-v fa-lg mt-4"></i><br/>arrows-v
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-asterisk fa-lg mt-4"></i><br/>asterisk
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-at fa-lg mt-4"></i><br/>at
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-automobile fa-lg mt-4"></i><br/>automobile <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-balance-scale fa-lg mt-4"></i><br/>balance-scale
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ban fa-lg mt-4"></i><br/>ban
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bank fa-lg mt-4"></i><br/>bank <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bar-chart fa-lg mt-4"></i><br/>bar-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bar-chart-o fa-lg mt-4"></i><br/>bar-chart-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-barcode fa-lg mt-4"></i><br/>barcode
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bars fa-lg mt-4"></i><br/>bars
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-0 fa-lg mt-4"></i><br/>battery-0 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-1 fa-lg mt-4"></i><br/>battery-1 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-2 fa-lg mt-4"></i><br/>battery-2 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-3 fa-lg mt-4"></i><br/>battery-3 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-4 fa-lg mt-4"></i><br/>battery-4 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-empty fa-lg mt-4"></i><br/>battery-empty
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-full fa-lg mt-4"></i><br/>battery-full
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-half fa-lg mt-4"></i><br/>battery-half
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-quarter fa-lg mt-4"></i><br/>battery-quarter
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-battery-three-quarters fa-lg mt-4"></i><br/>battery-three-quarters
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bed fa-lg mt-4"></i><br/>bed
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-beer fa-lg mt-4"></i><br/>beer
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bell fa-lg mt-4"></i><br/>bell
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bell-o fa-lg mt-4"></i><br/>bell-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bell-slash fa-lg mt-4"></i><br/>bell-slash
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bell-slash-o fa-lg mt-4"></i><br/>bell-slash-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bicycle fa-lg mt-4"></i><br/>bicycle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-binoculars fa-lg mt-4"></i><br/>binoculars
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-birthday-cake fa-lg mt-4"></i><br/>birthday-cake
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bluetooth fa-lg mt-4"></i><br/>bluetooth
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bluetooth-b fa-lg mt-4"></i><br/>bluetooth-b
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bolt fa-lg mt-4"></i><br/>bolt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bomb fa-lg mt-4"></i><br/>bomb
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-book fa-lg mt-4"></i><br/>book
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bookmark fa-lg mt-4"></i><br/>bookmark
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bookmark-o fa-lg mt-4"></i><br/>bookmark-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-briefcase fa-lg mt-4"></i><br/>briefcase
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bug fa-lg mt-4"></i><br/>bug
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-building fa-lg mt-4"></i><br/>building
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-building-o fa-lg mt-4"></i><br/>building-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bullhorn fa-lg mt-4"></i><br/>bullhorn
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bullseye fa-lg mt-4"></i><br/>bullseye
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bus fa-lg mt-4"></i><br/>bus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cab fa-lg mt-4"></i><br/>cab <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calculator fa-lg mt-4"></i><br/>calculator
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calendar fa-lg mt-4"></i><br/>calendar
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calendar-check-o fa-lg mt-4"></i><br/>calendar-check-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calendar-minus-o fa-lg mt-4"></i><br/>calendar-minus-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calendar-o fa-lg mt-4"></i><br/>calendar-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calendar-plus-o fa-lg mt-4"></i><br/>calendar-plus-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-calendar-times-o fa-lg mt-4"></i><br/>calendar-times-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-camera fa-lg mt-4"></i><br/>camera
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-camera-retro fa-lg mt-4"></i><br/>camera-retro
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-car fa-lg mt-4"></i><br/>car
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-down fa-lg mt-4"></i><br/>caret-square-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-left fa-lg mt-4"></i><br/>caret-square-o-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-right fa-lg mt-4"></i><br/>caret-square-o-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-up fa-lg mt-4"></i><br/>caret-square-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cart-arrow-down fa-lg mt-4"></i><br/>cart-arrow-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cart-plus fa-lg mt-4"></i><br/>cart-plus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc fa-lg mt-4"></i><br/>cc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-certificate fa-lg mt-4"></i><br/>certificate
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check fa-lg mt-4"></i><br/>check
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check-circle fa-lg mt-4"></i><br/>check-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check-circle-o fa-lg mt-4"></i><br/>check-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check-square fa-lg mt-4"></i><br/>check-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check-square-o fa-lg mt-4"></i><br/>check-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-child fa-lg mt-4"></i><br/>child
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle fa-lg mt-4"></i><br/>circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle-o fa-lg mt-4"></i><br/>circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle-o-notch fa-lg mt-4"></i><br/>circle-o-notch
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle-thin fa-lg mt-4"></i><br/>circle-thin
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-clock-o fa-lg mt-4"></i><br/>clock-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-clone fa-lg mt-4"></i><br/>clone
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-close fa-lg mt-4"></i><br/>close <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cloud fa-lg mt-4"></i><br/>cloud
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cloud-download fa-lg mt-4"></i><br/>cloud-download
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cloud-upload fa-lg mt-4"></i><br/>cloud-upload
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-code fa-lg mt-4"></i><br/>code
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-code-fork fa-lg mt-4"></i><br/>code-fork
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-coffee fa-lg mt-4"></i><br/>coffee
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cog fa-lg mt-4"></i><br/>cog
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cogs fa-lg mt-4"></i><br/>cogs
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-comment fa-lg mt-4"></i><br/>comment
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-comment-o fa-lg mt-4"></i><br/>comment-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-commenting fa-lg mt-4"></i><br/>commenting
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-commenting-o fa-lg mt-4"></i><br/>commenting-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-comments fa-lg mt-4"></i><br/>comments
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-comments-o fa-lg mt-4"></i><br/>comments-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-compass fa-lg mt-4"></i><br/>compass
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-copyright fa-lg mt-4"></i><br/>copyright
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-creative-commons fa-lg mt-4"></i><br/>creative-commons
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-credit-card fa-lg mt-4"></i><br/>credit-card
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-credit-card-alt fa-lg mt-4"></i><br/>credit-card-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-crop fa-lg mt-4"></i><br/>crop
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-crosshairs fa-lg mt-4"></i><br/>crosshairs
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cube fa-lg mt-4"></i><br/>cube
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cubes fa-lg mt-4"></i><br/>cubes
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cutlery fa-lg mt-4"></i><br/>cutlery
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dashboard fa-lg mt-4"></i><br/>dashboard <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-database fa-lg mt-4"></i><br/>database
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-desktop fa-lg mt-4"></i><br/>desktop
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-diamond fa-lg mt-4"></i><br/>diamond
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dot-circle-o fa-lg mt-4"></i><br/>dot-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-download fa-lg mt-4"></i><br/>download
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-edit fa-lg mt-4"></i><br/>edit <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ellipsis-h fa-lg mt-4"></i><br/>ellipsis-h
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ellipsis-v fa-lg mt-4"></i><br/>ellipsis-v
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-envelope fa-lg mt-4"></i><br/>envelope
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-envelope-o fa-lg mt-4"></i><br/>envelope-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-envelope-square fa-lg mt-4"></i><br/>envelope-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eraser fa-lg mt-4"></i><br/>eraser
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-exchange fa-lg mt-4"></i><br/>exchange
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-exclamation fa-lg mt-4"></i><br/>exclamation
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-exclamation-circle fa-lg mt-4"></i><br/>exclamation-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-exclamation-triangle fa-lg mt-4"></i><br/>exclamation-triangle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-external-link fa-lg mt-4"></i><br/>external-link
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-external-link-square fa-lg mt-4"></i><br/>external-link-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eye fa-lg mt-4"></i><br/>eye
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eye-slash fa-lg mt-4"></i><br/>eye-slash
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eyedropper fa-lg mt-4"></i><br/>eyedropper
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fax fa-lg mt-4"></i><br/>fax
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-feed fa-lg mt-4"></i><br/>feed <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-female fa-lg mt-4"></i><br/>female
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fighter-jet fa-lg mt-4"></i><br/>fighter-jet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-archive-o fa-lg mt-4"></i><br/>file-archive-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-audio-o fa-lg mt-4"></i><br/>file-audio-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-code-o fa-lg mt-4"></i><br/>file-code-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-excel-o fa-lg mt-4"></i><br/>file-excel-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-image-o fa-lg mt-4"></i><br/>file-image-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-movie-o fa-lg mt-4"></i><br/>file-movie-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-pdf-o fa-lg mt-4"></i><br/>file-pdf-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-photo-o fa-lg mt-4"></i><br/>file-photo-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-picture-o fa-lg mt-4"></i><br/>file-picture-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-powerpoint-o fa-lg mt-4"></i><br/>file-powerpoint-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-sound-o fa-lg mt-4"></i><br/>file-sound-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-video-o fa-lg mt-4"></i><br/>file-video-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-word-o fa-lg mt-4"></i><br/>file-word-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-zip-o fa-lg mt-4"></i><br/>file-zip-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-film fa-lg mt-4"></i><br/>film
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-filter fa-lg mt-4"></i><br/>filter
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fire fa-lg mt-4"></i><br/>fire
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fire-extinguisher fa-lg mt-4"></i><br/>fire-extinguisher
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-flag fa-lg mt-4"></i><br/>flag
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-flag-checkered fa-lg mt-4"></i><br/>flag-checkered
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-flag-o fa-lg mt-4"></i><br/>flag-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-flash fa-lg mt-4"></i><br/>flash <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-flask fa-lg mt-4"></i><br/>flask
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-folder fa-lg mt-4"></i><br/>folder
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-folder-o fa-lg mt-4"></i><br/>folder-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-folder-open fa-lg mt-4"></i><br/>folder-open
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-folder-open-o fa-lg mt-4"></i><br/>folder-open-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-frown-o fa-lg mt-4"></i><br/>frown-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-futbol-o fa-lg mt-4"></i><br/>futbol-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gamepad fa-lg mt-4"></i><br/>gamepad
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gavel fa-lg mt-4"></i><br/>gavel
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gear fa-lg mt-4"></i><br/>gear <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gears fa-lg mt-4"></i><br/>gears <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gift fa-lg mt-4"></i><br/>gift
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-glass fa-lg mt-4"></i><br/>glass
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-globe fa-lg mt-4"></i><br/>globe
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-graduation-cap fa-lg mt-4"></i><br/>graduation-cap
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-group fa-lg mt-4"></i><br/>group <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-grab-o fa-lg mt-4"></i><br/>hand-grab-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-lizard-o fa-lg mt-4"></i><br/>hand-lizard-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-paper-o fa-lg mt-4"></i><br/>hand-paper-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-peace-o fa-lg mt-4"></i><br/>hand-peace-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-pointer-o fa-lg mt-4"></i><br/>hand-pointer-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-rock-o fa-lg mt-4"></i><br/>hand-rock-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-scissors-o fa-lg mt-4"></i><br/>hand-scissors-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-spock-o fa-lg mt-4"></i><br/>hand-spock-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-stop-o fa-lg mt-4"></i><br/>hand-stop-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hashtag fa-lg mt-4"></i><br/>hashtag
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hdd-o fa-lg mt-4"></i><br/>hdd-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-headphones fa-lg mt-4"></i><br/>headphones
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-heart fa-lg mt-4"></i><br/>heart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-heart-o fa-lg mt-4"></i><br/>heart-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-heartbeat fa-lg mt-4"></i><br/>heartbeat
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-history fa-lg mt-4"></i><br/>history
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-home fa-lg mt-4"></i><br/>home
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hotel fa-lg mt-4"></i><br/>hotel <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass fa-lg mt-4"></i><br/>hourglass
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-1 fa-lg mt-4"></i><br/>hourglass-1 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-2 fa-lg mt-4"></i><br/>hourglass-2 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-3 fa-lg mt-4"></i><br/>hourglass-3 <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-end fa-lg mt-4"></i><br/>hourglass-end
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-half fa-lg mt-4"></i><br/>hourglass-half
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-o fa-lg mt-4"></i><br/>hourglass-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hourglass-start fa-lg mt-4"></i><br/>hourglass-start
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-i-cursor fa-lg mt-4"></i><br/>i-cursor
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-image fa-lg mt-4"></i><br/>image <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-inbox fa-lg mt-4"></i><br/>inbox
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-industry fa-lg mt-4"></i><br/>industry
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-info fa-lg mt-4"></i><br/>info
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-info-circle fa-lg mt-4"></i><br/>info-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-institution fa-lg mt-4"></i><br/>institution <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-key fa-lg mt-4"></i><br/>key
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-keyboard-o fa-lg mt-4"></i><br/>keyboard-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-language fa-lg mt-4"></i><br/>language
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-laptop fa-lg mt-4"></i><br/>laptop
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-leaf fa-lg mt-4"></i><br/>leaf
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-legal fa-lg mt-4"></i><br/>legal <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-lemon-o fa-lg mt-4"></i><br/>lemon-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-level-down fa-lg mt-4"></i><br/>level-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-level-up fa-lg mt-4"></i><br/>level-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-life-bouy fa-lg mt-4"></i><br/>life-bouy <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-life-buoy fa-lg mt-4"></i><br/>life-buoy <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-life-ring fa-lg mt-4"></i><br/>life-ring
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-life-saver fa-lg mt-4"></i><br/>life-saver <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-lightbulb-o fa-lg mt-4"></i><br/>lightbulb-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-line-chart fa-lg mt-4"></i><br/>line-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-location-arrow fa-lg mt-4"></i><br/>location-arrow
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-lock fa-lg mt-4"></i><br/>lock
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-magic fa-lg mt-4"></i><br/>magic
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-magnet fa-lg mt-4"></i><br/>magnet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mail-forward fa-lg mt-4"></i><br/>mail-forward <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mail-reply fa-lg mt-4"></i><br/>mail-reply <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mail-reply-all fa-lg mt-4"></i><br/>mail-reply-all <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-male fa-lg mt-4"></i><br/>male
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-map fa-lg mt-4"></i><br/>map
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-map-marker fa-lg mt-4"></i><br/>map-marker
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-map-o fa-lg mt-4"></i><br/>map-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-map-pin fa-lg mt-4"></i><br/>map-pin
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-map-signs fa-lg mt-4"></i><br/>map-signs
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-meh-o fa-lg mt-4"></i><br/>meh-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-microphone fa-lg mt-4"></i><br/>microphone
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-microphone-slash fa-lg mt-4"></i><br/>microphone-slash
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-minus fa-lg mt-4"></i><br/>minus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-minus-circle fa-lg mt-4"></i><br/>minus-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-minus-square fa-lg mt-4"></i><br/>minus-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-minus-square-o fa-lg mt-4"></i><br/>minus-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mobile fa-lg mt-4"></i><br/>mobile
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mobile-phone fa-lg mt-4"></i><br/>mobile-phone <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-money fa-lg mt-4"></i><br/>money
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-moon-o fa-lg mt-4"></i><br/>moon-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mortar-board fa-lg mt-4"></i><br/>mortar-board <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-motorcycle fa-lg mt-4"></i><br/>motorcycle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mouse-pointer fa-lg mt-4"></i><br/>mouse-pointer
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-music fa-lg mt-4"></i><br/>music
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-navicon fa-lg mt-4"></i><br/>navicon <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-newspaper-o fa-lg mt-4"></i><br/>newspaper-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-object-group fa-lg mt-4"></i><br/>object-group
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-object-ungroup fa-lg mt-4"></i><br/>object-ungroup
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paint-brush fa-lg mt-4"></i><br/>paint-brush
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paper-plane fa-lg mt-4"></i><br/>paper-plane
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paper-plane-o fa-lg mt-4"></i><br/>paper-plane-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paw fa-lg mt-4"></i><br/>paw
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pencil fa-lg mt-4"></i><br/>pencil
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pencil-square fa-lg mt-4"></i><br/>pencil-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pencil-square-o fa-lg mt-4"></i><br/>pencil-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-percent fa-lg mt-4"></i><br/>percent
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-phone fa-lg mt-4"></i><br/>phone
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-phone-square fa-lg mt-4"></i><br/>phone-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-photo fa-lg mt-4"></i><br/>photo <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-picture-o fa-lg mt-4"></i><br/>picture-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pie-chart fa-lg mt-4"></i><br/>pie-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plane fa-lg mt-4"></i><br/>plane
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plug fa-lg mt-4"></i><br/>plug
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus fa-lg mt-4"></i><br/>plus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus-circle fa-lg mt-4"></i><br/>plus-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus-square fa-lg mt-4"></i><br/>plus-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus-square-o fa-lg mt-4"></i><br/>plus-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-power-off fa-lg mt-4"></i><br/>power-off
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-print fa-lg mt-4"></i><br/>print
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-puzzle-piece fa-lg mt-4"></i><br/>puzzle-piece
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-qrcode fa-lg mt-4"></i><br/>qrcode
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-question fa-lg mt-4"></i><br/>question
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-question-circle fa-lg mt-4"></i><br/>question-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-quote-left fa-lg mt-4"></i><br/>quote-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-quote-right fa-lg mt-4"></i><br/>quote-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-random fa-lg mt-4"></i><br/>random
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-recycle fa-lg mt-4"></i><br/>recycle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-refresh fa-lg mt-4"></i><br/>refresh
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-registered fa-lg mt-4"></i><br/>registered
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-remove fa-lg mt-4"></i><br/>remove <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reorder fa-lg mt-4"></i><br/>reorder <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reply fa-lg mt-4"></i><br/>reply
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reply-all fa-lg mt-4"></i><br/>reply-all
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-retweet fa-lg mt-4"></i><br/>retweet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-road fa-lg mt-4"></i><br/>road
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rocket fa-lg mt-4"></i><br/>rocket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rss fa-lg mt-4"></i><br/>rss
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rss-square fa-lg mt-4"></i><br/>rss-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-search fa-lg mt-4"></i><br/>search
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-search-minus fa-lg mt-4"></i><br/>search-minus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-search-plus fa-lg mt-4"></i><br/>search-plus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-send fa-lg mt-4"></i><br/>send <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-send-o fa-lg mt-4"></i><br/>send-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-server fa-lg mt-4"></i><br/>server
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share fa-lg mt-4"></i><br/>share
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share-alt fa-lg mt-4"></i><br/>share-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share-alt-square fa-lg mt-4"></i><br/>share-alt-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share-square fa-lg mt-4"></i><br/>share-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share-square-o fa-lg mt-4"></i><br/>share-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shield fa-lg mt-4"></i><br/>shield
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ship fa-lg mt-4"></i><br/>ship
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shopping-bag fa-lg mt-4"></i><br/>shopping-bag
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shopping-basket fa-lg mt-4"></i><br/>shopping-basket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shopping-cart fa-lg mt-4"></i><br/>shopping-cart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sign-in fa-lg mt-4"></i><br/>sign-in
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sign-out fa-lg mt-4"></i><br/>sign-out
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-signal fa-lg mt-4"></i><br/>signal
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sitemap fa-lg mt-4"></i><br/>sitemap
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sliders fa-lg mt-4"></i><br/>sliders
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-smile-o fa-lg mt-4"></i><br/>smile-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-soccer-ball-o fa-lg mt-4"></i><br/>soccer-ball-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort fa-lg mt-4"></i><br/>sort
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-alpha-asc fa-lg mt-4"></i><br/>sort-alpha-asc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-alpha-desc fa-lg mt-4"></i><br/>sort-alpha-desc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-amount-asc fa-lg mt-4"></i><br/>sort-amount-asc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-amount-desc fa-lg mt-4"></i><br/>sort-amount-desc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-asc fa-lg mt-4"></i><br/>sort-asc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-desc fa-lg mt-4"></i><br/>sort-desc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-down fa-lg mt-4"></i><br/>sort-down <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-numeric-asc fa-lg mt-4"></i><br/>sort-numeric-asc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-numeric-desc fa-lg mt-4"></i><br/>sort-numeric-desc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sort-up fa-lg mt-4"></i><br/>sort-up <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-space-shuttle fa-lg mt-4"></i><br/>space-shuttle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-spinner fa-lg mt-4"></i><br/>spinner
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-spoon fa-lg mt-4"></i><br/>spoon
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-square fa-lg mt-4"></i><br/>square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-square-o fa-lg mt-4"></i><br/>square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-star fa-lg mt-4"></i><br/>star
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-star-half fa-lg mt-4"></i><br/>star-half
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-star-half-empty fa-lg mt-4"></i><br/>star-half-empty <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-star-half-full fa-lg mt-4"></i><br/>star-half-full <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-star-half-o fa-lg mt-4"></i><br/>star-half-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-star-o fa-lg mt-4"></i><br/>star-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sticky-note fa-lg mt-4"></i><br/>sticky-note
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sticky-note-o fa-lg mt-4"></i><br/>sticky-note-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-street-view fa-lg mt-4"></i><br/>street-view
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-suitcase fa-lg mt-4"></i><br/>suitcase
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sun-o fa-lg mt-4"></i><br/>sun-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-support fa-lg mt-4"></i><br/>support <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tablet fa-lg mt-4"></i><br/>tablet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tachometer fa-lg mt-4"></i><br/>tachometer
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tag fa-lg mt-4"></i><br/>tag
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tags fa-lg mt-4"></i><br/>tags
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tasks fa-lg mt-4"></i><br/>tasks
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-taxi fa-lg mt-4"></i><br/>taxi
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-television fa-lg mt-4"></i><br/>television
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-terminal fa-lg mt-4"></i><br/>terminal
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumb-tack fa-lg mt-4"></i><br/>thumb-tack
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-down fa-lg mt-4"></i><br/>thumbs-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-o-down fa-lg mt-4"></i><br/>thumbs-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-o-up fa-lg mt-4"></i><br/>thumbs-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-up fa-lg mt-4"></i><br/>thumbs-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ticket fa-lg mt-4"></i><br/>ticket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-times fa-lg mt-4"></i><br/>times
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-times-circle fa-lg mt-4"></i><br/>times-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-times-circle-o fa-lg mt-4"></i><br/>times-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tint fa-lg mt-4"></i><br/>tint
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-down fa-lg mt-4"></i><br/>toggle-down <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-left fa-lg mt-4"></i><br/>toggle-left <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-off fa-lg mt-4"></i><br/>toggle-off
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-on fa-lg mt-4"></i><br/>toggle-on
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-right fa-lg mt-4"></i><br/>toggle-right <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-up fa-lg mt-4"></i><br/>toggle-up <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-trademark fa-lg mt-4"></i><br/>trademark
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-trash fa-lg mt-4"></i><br/>trash
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-trash-o fa-lg mt-4"></i><br/>trash-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tree fa-lg mt-4"></i><br/>tree
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-trophy fa-lg mt-4"></i><br/>trophy
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-truck fa-lg mt-4"></i><br/>truck
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tty fa-lg mt-4"></i><br/>tty
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tv fa-lg mt-4"></i><br/>tv <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-umbrella fa-lg mt-4"></i><br/>umbrella
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-university fa-lg mt-4"></i><br/>university
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-unlock fa-lg mt-4"></i><br/>unlock
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-unlock-alt fa-lg mt-4"></i><br/>unlock-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-unsorted fa-lg mt-4"></i><br/>unsorted <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-upload fa-lg mt-4"></i><br/>upload
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-user fa-lg mt-4"></i><br/>user
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-user-plus fa-lg mt-4"></i><br/>user-plus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-user-secret fa-lg mt-4"></i><br/>user-secret
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-user-times fa-lg mt-4"></i><br/>user-times
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-users fa-lg mt-4"></i><br/>users
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-video-camera fa-lg mt-4"></i><br/>video-camera
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-volume-down fa-lg mt-4"></i><br/>volume-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-volume-off fa-lg mt-4"></i><br/>volume-off
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-volume-up fa-lg mt-4"></i><br/>volume-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-warning fa-lg mt-4"></i><br/>warning <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wheelchair fa-lg mt-4"></i><br/>wheelchair
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wifi fa-lg mt-4"></i><br/>wifi
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wrench fa-lg mt-4"></i><br/>wrench
        </div>

      </div>
    </div>

  </div>

  <div className="card" id="hand">
    <div className="card-header">Hand Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-grab-o fa-lg mt-4"></i><br/>hand-grab-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-lizard-o fa-lg mt-4"></i><br/>hand-lizard-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-down fa-lg mt-4"></i><br/>hand-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-left fa-lg mt-4"></i><br/>hand-o-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-right fa-lg mt-4"></i><br/>hand-o-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-up fa-lg mt-4"></i><br/>hand-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-paper-o fa-lg mt-4"></i><br/>hand-paper-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-peace-o fa-lg mt-4"></i><br/>hand-peace-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-pointer-o fa-lg mt-4"></i><br/>hand-pointer-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-rock-o fa-lg mt-4"></i><br/>hand-rock-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-scissors-o fa-lg mt-4"></i><br/>hand-scissors-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-spock-o fa-lg mt-4"></i><br/>hand-spock-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-stop-o fa-lg mt-4"></i><br/>hand-stop-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-down fa-lg mt-4"></i><br/>thumbs-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-o-down fa-lg mt-4"></i><br/>thumbs-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-o-up fa-lg mt-4"></i><br/>thumbs-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-thumbs-up fa-lg mt-4"></i><br/>thumbs-up
        </div>

      </div>
    </div>

  </div>

  <div className="card" id="transportation">
    <div className="card-header">Transportation Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ambulance fa-lg mt-4"></i><br/>ambulance
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-automobile fa-lg mt-4"></i><br/>automobile <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bicycle fa-lg mt-4"></i><br/>bicycle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bus fa-lg mt-4"></i><br/>bus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cab fa-lg mt-4"></i><br/>cab <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-car fa-lg mt-4"></i><br/>car
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fighter-jet fa-lg mt-4"></i><br/>fighter-jet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-motorcycle fa-lg mt-4"></i><br/>motorcycle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plane fa-lg mt-4"></i><br/>plane
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rocket fa-lg mt-4"></i><br/>rocket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ship fa-lg mt-4"></i><br/>ship
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-space-shuttle fa-lg mt-4"></i><br/>space-shuttle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-subway fa-lg mt-4"></i><br/>subway
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-taxi fa-lg mt-4"></i><br/>taxi
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-train fa-lg mt-4"></i><br/>train
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-truck fa-lg mt-4"></i><br/>truck
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wheelchair fa-lg mt-4"></i><br/>wheelchair
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="gender">
    <div className="card-header">Gender Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-genderless fa-lg mt-4"></i><br/>genderless
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-intersex fa-lg mt-4"></i><br/>intersex <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mars fa-lg mt-4"></i><br/>mars
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mars-double fa-lg mt-4"></i><br/>mars-double
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mars-stroke fa-lg mt-4"></i><br/>mars-stroke
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mars-stroke-h fa-lg mt-4"></i><br/>mars-stroke-h
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mars-stroke-v fa-lg mt-4"></i><br/>mars-stroke-v
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mercury fa-lg mt-4"></i><br/>mercury
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-neuter fa-lg mt-4"></i><br/>neuter
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-transgender fa-lg mt-4"></i><br/>transgender
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-transgender-alt fa-lg mt-4"></i><br/>transgender-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-venus fa-lg mt-4"></i><br/>venus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-venus-double fa-lg mt-4"></i><br/>venus-double
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-venus-mars fa-lg mt-4"></i><br/>venus-mars
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="file-type">
    <div className="card-header">File Type Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file fa-lg mt-4"></i><br/>file
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-archive-o fa-lg mt-4"></i><br/>file-archive-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-audio-o fa-lg mt-4"></i><br/>file-audio-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-code-o fa-lg mt-4"></i><br/>file-code-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-excel-o fa-lg mt-4"></i><br/>file-excel-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-image-o fa-lg mt-4"></i><br/>file-image-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-movie-o fa-lg mt-4"></i><br/>file-movie-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-o fa-lg mt-4"></i><br/>file-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-pdf-o fa-lg mt-4"></i><br/>file-pdf-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-photo-o fa-lg mt-4"></i><br/>file-photo-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-picture-o fa-lg mt-4"></i><br/>file-picture-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-powerpoint-o fa-lg mt-4"></i><br/>file-powerpoint-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-sound-o fa-lg mt-4"></i><br/>file-sound-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-text fa-lg mt-4"></i><br/>file-text
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-text-o fa-lg mt-4"></i><br/>file-text-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-video-o fa-lg mt-4"></i><br/>file-video-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-word-o fa-lg mt-4"></i><br/>file-word-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-zip-o fa-lg mt-4"></i><br/>file-zip-o <span className="text-muted">(alias)</span>
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="spinner">
    <div className="card-header">Spinner Icons</div>
    <div className="card-block">
      <div className="alert alert-success">
        <ul className="fa-ul">
          <li>
            <i className="fa fa-info-circle fa-li"></i>
            These icons work great with the <code>fa-spin</code> class.
          </li>
        </ul>
      </div>
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle-o-notch fa-lg mt-4"></i><br/>circle-o-notch
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cog fa-lg mt-4"></i><br/>cog
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gear fa-lg mt-4"></i><br/>gear <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-refresh fa-lg mt-4"></i><br/>refresh
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-spinner fa-lg mt-4"></i><br/>spinner
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="form-control">
    <div className="card-header">Form Control Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check-square fa-lg mt-4"></i><br/>check-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-check-square-o fa-lg mt-4"></i><br/>check-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle fa-lg mt-4"></i><br/>circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-circle-o fa-lg mt-4"></i><br/>circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dot-circle-o fa-lg mt-4"></i><br/>dot-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-minus-square fa-lg mt-4"></i><br/>minus-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-minus-square-o fa-lg mt-4"></i><br/>minus-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus-square fa-lg mt-4"></i><br/>plus-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus-square-o fa-lg mt-4"></i><br/>plus-square-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-square fa-lg mt-4"></i><br/>square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-square-o fa-lg mt-4"></i><br/>square-o
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="payment">
    <div className="card-header">Payment Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-amex fa-lg mt-4"></i><br/>cc-amex
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-diners-club fa-lg mt-4"></i><br/>cc-diners-club
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-discover fa-lg mt-4"></i><br/>cc-discover
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-jcb fa-lg mt-4"></i><br/>cc-jcb
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-mastercard fa-lg mt-4"></i><br/>cc-mastercard
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-paypal fa-lg mt-4"></i><br/>cc-paypal
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-stripe fa-lg mt-4"></i><br/>cc-stripe
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-visa fa-lg mt-4"></i><br/>cc-visa
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-credit-card fa-lg mt-4"></i><br/>credit-card
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-credit-card-alt fa-lg mt-4"></i><br/>credit-card-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-google-wallet fa-lg mt-4"></i><br/>google-wallet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paypal fa-lg mt-4"></i><br/>paypal
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="chart">
    <div className="card-header">Chart Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-area-chart fa-lg mt-4"></i><br/>area-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bar-chart fa-lg mt-4"></i><br/>bar-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bar-chart-o fa-lg mt-4"></i><br/>bar-chart-o <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-line-chart fa-lg mt-4"></i><br/>line-chart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pie-chart fa-lg mt-4"></i><br/>pie-chart
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="currency">
    <div className="card-header">Currency Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bitcoin fa-lg mt-4"></i><br/>bitcoin <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-btc fa-lg mt-4"></i><br/>btc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cny fa-lg mt-4"></i><br/>cny <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dollar fa-lg mt-4"></i><br/>dollar <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eur fa-lg mt-4"></i><br/>eur
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-euro fa-lg mt-4"></i><br/>euro <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gbp fa-lg mt-4"></i><br/>gbp
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gg fa-lg mt-4"></i><br/>gg
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gg-circle fa-lg mt-4"></i><br/>gg-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ils fa-lg mt-4"></i><br/>ils
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-inr fa-lg mt-4"></i><br/>inr
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-jpy fa-lg mt-4"></i><br/>jpy
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-krw fa-lg mt-4"></i><br/>krw
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-money fa-lg mt-4"></i><br/>money
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rmb fa-lg mt-4"></i><br/>rmb <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rouble fa-lg mt-4"></i><br/>rouble <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rub fa-lg mt-4"></i><br/>rub
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ruble fa-lg mt-4"></i><br/>ruble <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rupee fa-lg mt-4"></i><br/>rupee <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shekel fa-lg mt-4"></i><br/>shekel <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sheqel fa-lg mt-4"></i><br/>sheqel <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-try fa-lg mt-4"></i><br/>try
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-turkish-lira fa-lg mt-4"></i><br/>turkish-lira <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-usd fa-lg mt-4"></i><br/>usd
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-won fa-lg mt-4"></i><br/>won <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-yen fa-lg mt-4"></i><br/>yen <span className="text-muted">(alias)</span>
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="text-editor">
    <div className="card-header">Text Editor Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-align-center fa-lg mt-4"></i><br/>align-center
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-align-justify fa-lg mt-4"></i><br/>align-justify
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-align-left fa-lg mt-4"></i><br/>align-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-align-right fa-lg mt-4"></i><br/>align-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bold fa-lg mt-4"></i><br/>bold
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chain fa-lg mt-4"></i><br/>chain <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chain-broken fa-lg mt-4"></i><br/>chain-broken
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-clipboard fa-lg mt-4"></i><br/>clipboard
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-columns fa-lg mt-4"></i><br/>columns
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-copy fa-lg mt-4"></i><br/>copy <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cut fa-lg mt-4"></i><br/>cut <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dedent fa-lg mt-4"></i><br/>dedent <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eraser fa-lg mt-4"></i><br/>eraser
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file fa-lg mt-4"></i><br/>file
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-o fa-lg mt-4"></i><br/>file-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-text fa-lg mt-4"></i><br/>file-text
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-file-text-o fa-lg mt-4"></i><br/>file-text-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-files-o fa-lg mt-4"></i><br/>files-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-floppy-o fa-lg mt-4"></i><br/>floppy-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-font fa-lg mt-4"></i><br/>font
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-header fa-lg mt-4"></i><br/>header
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-indent fa-lg mt-4"></i><br/>indent
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-italic fa-lg mt-4"></i><br/>italic
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-link fa-lg mt-4"></i><br/>link
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-list fa-lg mt-4"></i><br/>list
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-list-alt fa-lg mt-4"></i><br/>list-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-list-ol fa-lg mt-4"></i><br/>list-ol
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-list-ul fa-lg mt-4"></i><br/>list-ul
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-outdent fa-lg mt-4"></i><br/>outdent
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paperclip fa-lg mt-4"></i><br/>paperclip
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paragraph fa-lg mt-4"></i><br/>paragraph
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paste fa-lg mt-4"></i><br/>paste <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-repeat fa-lg mt-4"></i><br/>repeat
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rotate-left fa-lg mt-4"></i><br/>rotate-left <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rotate-right fa-lg mt-4"></i><br/>rotate-right <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-save fa-lg mt-4"></i><br/>save <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-scissors fa-lg mt-4"></i><br/>scissors
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-strikethrough fa-lg mt-4"></i><br/>strikethrough
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-subscript fa-lg mt-4"></i><br/>subscript
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-superscript fa-lg mt-4"></i><br/>superscript
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-table fa-lg mt-4"></i><br/>table
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-text-height fa-lg mt-4"></i><br/>text-height
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-text-width fa-lg mt-4"></i><br/>text-width
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-th fa-lg mt-4"></i><br/>th
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-th-large fa-lg mt-4"></i><br/>th-large
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-th-list fa-lg mt-4"></i><br/>th-list
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-underline fa-lg mt-4"></i><br/>underline
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-undo fa-lg mt-4"></i><br/>undo
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-unlink fa-lg mt-4"></i><br/>unlink <span className="text-muted">(alias)</span>
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="directional">
    <div className="card-header">Directional Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-double-down fa-lg mt-4"></i><br/>angle-double-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-double-left fa-lg mt-4"></i><br/>angle-double-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-double-right fa-lg mt-4"></i><br/>angle-double-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-double-up fa-lg mt-4"></i><br/>angle-double-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-down fa-lg mt-4"></i><br/>angle-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-left fa-lg mt-4"></i><br/>angle-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-right fa-lg mt-4"></i><br/>angle-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angle-up fa-lg mt-4"></i><br/>angle-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-down fa-lg mt-4"></i><br/>arrow-circle-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-left fa-lg mt-4"></i><br/>arrow-circle-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-o-down fa-lg mt-4"></i><br/>arrow-circle-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-o-left fa-lg mt-4"></i><br/>arrow-circle-o-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-o-right fa-lg mt-4"></i><br/>arrow-circle-o-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-o-up fa-lg mt-4"></i><br/>arrow-circle-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-right fa-lg mt-4"></i><br/>arrow-circle-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-circle-up fa-lg mt-4"></i><br/>arrow-circle-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-down fa-lg mt-4"></i><br/>arrow-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-left fa-lg mt-4"></i><br/>arrow-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-right fa-lg mt-4"></i><br/>arrow-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrow-up fa-lg mt-4"></i><br/>arrow-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows fa-lg mt-4"></i><br/>arrows
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows-alt fa-lg mt-4"></i><br/>arrows-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows-h fa-lg mt-4"></i><br/>arrows-h
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows-v fa-lg mt-4"></i><br/>arrows-v
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-down fa-lg mt-4"></i><br/>caret-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-left fa-lg mt-4"></i><br/>caret-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-right fa-lg mt-4"></i><br/>caret-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-down fa-lg mt-4"></i><br/>caret-square-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-left fa-lg mt-4"></i><br/>caret-square-o-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-right fa-lg mt-4"></i><br/>caret-square-o-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-square-o-up fa-lg mt-4"></i><br/>caret-square-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-caret-up fa-lg mt-4"></i><br/>caret-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-circle-down fa-lg mt-4"></i><br/>chevron-circle-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-circle-left fa-lg mt-4"></i><br/>chevron-circle-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-circle-right fa-lg mt-4"></i><br/>chevron-circle-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-circle-up fa-lg mt-4"></i><br/>chevron-circle-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-down fa-lg mt-4"></i><br/>chevron-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-left fa-lg mt-4"></i><br/>chevron-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-right fa-lg mt-4"></i><br/>chevron-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chevron-up fa-lg mt-4"></i><br/>chevron-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-exchange fa-lg mt-4"></i><br/>exchange
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-down fa-lg mt-4"></i><br/>hand-o-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-left fa-lg mt-4"></i><br/>hand-o-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-right fa-lg mt-4"></i><br/>hand-o-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hand-o-up fa-lg mt-4"></i><br/>hand-o-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-long-arrow-down fa-lg mt-4"></i><br/>long-arrow-down
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-long-arrow-left fa-lg mt-4"></i><br/>long-arrow-left
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-long-arrow-right fa-lg mt-4"></i><br/>long-arrow-right
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-long-arrow-up fa-lg mt-4"></i><br/>long-arrow-up
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-down fa-lg mt-4"></i><br/>toggle-down <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-left fa-lg mt-4"></i><br/>toggle-left <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-right fa-lg mt-4"></i><br/>toggle-right <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-toggle-up fa-lg mt-4"></i><br/>toggle-up <span className="text-muted">(alias)</span>
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="video-player">
    <div className="card-header">Video Player Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-arrows-alt fa-lg mt-4"></i><br/>arrows-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-backward fa-lg mt-4"></i><br/>backward
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-compress fa-lg mt-4"></i><br/>compress
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-eject fa-lg mt-4"></i><br/>eject
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-expand fa-lg mt-4"></i><br/>expand
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fast-backward fa-lg mt-4"></i><br/>fast-backward
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fast-forward fa-lg mt-4"></i><br/>fast-forward
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-forward fa-lg mt-4"></i><br/>forward
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pause fa-lg mt-4"></i><br/>pause
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pause-circle fa-lg mt-4"></i><br/>pause-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pause-circle-o fa-lg mt-4"></i><br/>pause-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-play fa-lg mt-4"></i><br/>play
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-play-circle fa-lg mt-4"></i><br/>play-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-play-circle-o fa-lg mt-4"></i><br/>play-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-random fa-lg mt-4"></i><br/>random
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-step-backward fa-lg mt-4"></i><br/>step-backward
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-step-forward fa-lg mt-4"></i><br/>step-forward
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stop fa-lg mt-4"></i><br/>stop
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stop-circle fa-lg mt-4"></i><br/>stop-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stop-circle-o fa-lg mt-4"></i><br/>stop-circle-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-youtube-play fa-lg mt-4"></i><br/>youtube-play
        </div>

      </div>
    </div>
  </div>

  <div className="card" id="brand">
    <div className="card-header">Brand Icons</div>
    <div className="card-block">
      <div className="alert alert-warning">
        <h4><i className="fa fa-warning"></i> Warning!</h4>
        Apparently, Adblock Plus can remove Font Awesome brand icons with their "Remove Social
        Media Buttons" setting. We will not use hacks to force them to display. Please
        <a href="https://adblockplus.org/en/bugs" className="alert-link">report an issue with Adblock Plus</a> if you believe this to be
        an error. To work around this, you'll need to modify the social icon class names.
      </div>
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-500px fa-lg mt-4"></i><br/>500px
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-adn fa-lg mt-4"></i><br/>adn
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-amazon fa-lg mt-4"></i><br/>amazon
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-android fa-lg mt-4"></i><br/>android
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-angellist fa-lg mt-4"></i><br/>angellist
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-apple fa-lg mt-4"></i><br/>apple
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-behance fa-lg mt-4"></i><br/>behance
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-behance-square fa-lg mt-4"></i><br/>behance-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bitbucket fa-lg mt-4"></i><br/>bitbucket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bitbucket-square fa-lg mt-4"></i><br/>bitbucket-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bitcoin fa-lg mt-4"></i><br/>bitcoin <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-black-tie fa-lg mt-4"></i><br/>black-tie
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bluetooth fa-lg mt-4"></i><br/>bluetooth
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-bluetooth-b fa-lg mt-4"></i><br/>bluetooth-b
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-btc fa-lg mt-4"></i><br/>btc
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-buysellads fa-lg mt-4"></i><br/>buysellads
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-amex fa-lg mt-4"></i><br/>cc-amex
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-diners-club fa-lg mt-4"></i><br/>cc-diners-club
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-discover fa-lg mt-4"></i><br/>cc-discover
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-jcb fa-lg mt-4"></i><br/>cc-jcb
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-mastercard fa-lg mt-4"></i><br/>cc-mastercard
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-paypal fa-lg mt-4"></i><br/>cc-paypal
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-stripe fa-lg mt-4"></i><br/>cc-stripe
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-cc-visa fa-lg mt-4"></i><br/>cc-visa
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-chrome fa-lg mt-4"></i><br/>chrome
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-codepen fa-lg mt-4"></i><br/>codepen
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-codiepie fa-lg mt-4"></i><br/>codiepie
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-connectdevelop fa-lg mt-4"></i><br/>connectdevelop
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-contao fa-lg mt-4"></i><br/>contao
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-css3 fa-lg mt-4"></i><br/>css3
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dashcube fa-lg mt-4"></i><br/>dashcube
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-delicious fa-lg mt-4"></i><br/>delicious
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-deviantart fa-lg mt-4"></i><br/>deviantart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-digg fa-lg mt-4"></i><br/>digg
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dribbble fa-lg mt-4"></i><br/>dribbble
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-dropbox fa-lg mt-4"></i><br/>dropbox
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-drupal fa-lg mt-4"></i><br/>drupal
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-edge fa-lg mt-4"></i><br/>edge
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-empire fa-lg mt-4"></i><br/>empire
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-expeditedssl fa-lg mt-4"></i><br/>expeditedssl
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-facebook fa-lg mt-4"></i><br/>facebook
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-facebook-f fa-lg mt-4"></i><br/>facebook-f <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-facebook-official fa-lg mt-4"></i><br/>facebook-official
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-facebook-square fa-lg mt-4"></i><br/>facebook-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-firefox fa-lg mt-4"></i><br/>firefox
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-flickr fa-lg mt-4"></i><br/>flickr
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fonticons fa-lg mt-4"></i><br/>fonticons
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-fort-awesome fa-lg mt-4"></i><br/>fort-awesome
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-forumbee fa-lg mt-4"></i><br/>forumbee
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-foursquare fa-lg mt-4"></i><br/>foursquare
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ge fa-lg mt-4"></i><br/>ge <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-get-pocket fa-lg mt-4"></i><br/>get-pocket
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gg fa-lg mt-4"></i><br/>gg
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gg-circle fa-lg mt-4"></i><br/>gg-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-git fa-lg mt-4"></i><br/>git
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-git-square fa-lg mt-4"></i><br/>git-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-github fa-lg mt-4"></i><br/>github
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-github-alt fa-lg mt-4"></i><br/>github-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-github-square fa-lg mt-4"></i><br/>github-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gittip fa-lg mt-4"></i><br/>gittip <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-google fa-lg mt-4"></i><br/>google
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-google-plus fa-lg mt-4"></i><br/>google-plus
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-google-plus-square fa-lg mt-4"></i><br/>google-plus-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-google-wallet fa-lg mt-4"></i><br/>google-wallet
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-gratipay fa-lg mt-4"></i><br/>gratipay
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hacker-news fa-lg mt-4"></i><br/>hacker-news
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-houzz fa-lg mt-4"></i><br/>houzz
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-html5 fa-lg mt-4"></i><br/>html5
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-instagram fa-lg mt-4"></i><br/>instagram
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-internet-explorer fa-lg mt-4"></i><br/>internet-explorer
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ioxhost fa-lg mt-4"></i><br/>ioxhost
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-joomla fa-lg mt-4"></i><br/>joomla
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-jsfiddle fa-lg mt-4"></i><br/>jsfiddle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-lastfm fa-lg mt-4"></i><br/>lastfm
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-lastfm-square fa-lg mt-4"></i><br/>lastfm-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-leanpub fa-lg mt-4"></i><br/>leanpub
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-linkedin fa-lg mt-4"></i><br/>linkedin
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-linkedin-square fa-lg mt-4"></i><br/>linkedin-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-linux fa-lg mt-4"></i><br/>linux
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-maxcdn fa-lg mt-4"></i><br/>maxcdn
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-meanpath fa-lg mt-4"></i><br/>meanpath
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-medium fa-lg mt-4"></i><br/>medium
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-mixcloud fa-lg mt-4"></i><br/>mixcloud
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-modx fa-lg mt-4"></i><br/>modx
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-odnoklassniki fa-lg mt-4"></i><br/>odnoklassniki
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-odnoklassniki-square fa-lg mt-4"></i><br/>odnoklassniki-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-opencart fa-lg mt-4"></i><br/>opencart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-openid fa-lg mt-4"></i><br/>openid
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-opera fa-lg mt-4"></i><br/>opera
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-optin-monster fa-lg mt-4"></i><br/>optin-monster
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pagelines fa-lg mt-4"></i><br/>pagelines
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-paypal fa-lg mt-4"></i><br/>paypal
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pied-piper fa-lg mt-4"></i><br/>pied-piper
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pied-piper-alt fa-lg mt-4"></i><br/>pied-piper-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pinterest fa-lg mt-4"></i><br/>pinterest
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pinterest-p fa-lg mt-4"></i><br/>pinterest-p
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-pinterest-square fa-lg mt-4"></i><br/>pinterest-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-product-hunt fa-lg mt-4"></i><br/>product-hunt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-qq fa-lg mt-4"></i><br/>qq
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ra fa-lg mt-4"></i><br/>ra <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-rebel fa-lg mt-4"></i><br/>rebel
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reddit fa-lg mt-4"></i><br/>reddit
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reddit-alien fa-lg mt-4"></i><br/>reddit-alien
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-reddit-square fa-lg mt-4"></i><br/>reddit-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-renren fa-lg mt-4"></i><br/>renren
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-safari fa-lg mt-4"></i><br/>safari
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-scribd fa-lg mt-4"></i><br/>scribd
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-sellsy fa-lg mt-4"></i><br/>sellsy
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share-alt fa-lg mt-4"></i><br/>share-alt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-share-alt-square fa-lg mt-4"></i><br/>share-alt-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-shirtsinbulk fa-lg mt-4"></i><br/>shirtsinbulk
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-simplybuilt fa-lg mt-4"></i><br/>simplybuilt
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-skyatlas fa-lg mt-4"></i><br/>skyatlas
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-skype fa-lg mt-4"></i><br/>skype
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-slack fa-lg mt-4"></i><br/>slack
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-slideshare fa-lg mt-4"></i><br/>slideshare
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-soundcloud fa-lg mt-4"></i><br/>soundcloud
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-spotify fa-lg mt-4"></i><br/>spotify
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stack-exchange fa-lg mt-4"></i><br/>stack-exchange
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stack-overflow fa-lg mt-4"></i><br/>stack-overflow
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-steam fa-lg mt-4"></i><br/>steam
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-steam-square fa-lg mt-4"></i><br/>steam-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stumbleupon fa-lg mt-4"></i><br/>stumbleupon
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stumbleupon-circle fa-lg mt-4"></i><br/>stumbleupon-circle
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tencent-weibo fa-lg mt-4"></i><br/>tencent-weibo
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-trello fa-lg mt-4"></i><br/>trello
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tripadvisor fa-lg mt-4"></i><br/>tripadvisor
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tumblr fa-lg mt-4"></i><br/>tumblr
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-tumblr-square fa-lg mt-4"></i><br/>tumblr-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-twitch fa-lg mt-4"></i><br/>twitch
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-twitter fa-lg mt-4"></i><br/>twitter
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-twitter-square fa-lg mt-4"></i><br/>twitter-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-usb fa-lg mt-4"></i><br/>usb
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-viacoin fa-lg mt-4"></i><br/>viacoin
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-vimeo fa-lg mt-4"></i><br/>vimeo
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-vimeo-square fa-lg mt-4"></i><br/>vimeo-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-vine fa-lg mt-4"></i><br/>vine
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-vk fa-lg mt-4"></i><br/>vk
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wechat fa-lg mt-4"></i><br/>wechat <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-weibo fa-lg mt-4"></i><br/>weibo
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-weixin fa-lg mt-4"></i><br/>weixin
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-whatsapp fa-lg mt-4"></i><br/>whatsapp
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wikipedia-w fa-lg mt-4"></i><br/>wikipedia-w
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-windows fa-lg mt-4"></i><br/>windows
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wordpress fa-lg mt-4"></i><br/>wordpress
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-xing fa-lg mt-4"></i><br/>xing
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-xing-square fa-lg mt-4"></i><br/>xing-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-y-combinator fa-lg mt-4"></i><br/>y-combinator
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-y-combinator-square fa-lg mt-4"></i><br/>y-combinator-square <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-yahoo fa-lg mt-4"></i><br/>yahoo
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-yc fa-lg mt-4"></i><br/>yc <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-yc-square fa-lg mt-4"></i><br/>yc-square <span className="text-muted">(alias)</span>
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-yelp fa-lg mt-4"></i><br/>yelp
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-youtube fa-lg mt-4"></i><br/>youtube
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-youtube-play fa-lg mt-4"></i><br/>youtube-play
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-youtube-square fa-lg mt-4"></i><br/>youtube-square
        </div>
      </div>
      <div className="alert alert-success mt-4">
        <ul className="margin-bottom-none padding-left-lg">
          <li>All brand icons are trademarks of their respective owners.</li>
          <li>The use of these trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor vice versa.</li>
          <li>Brand icons should only be used to represent the company or product to which they refer.</li>
        </ul>
      </div>
    </div>
  </div>

  <div className="card" id="medical">
    <div className="card-header">Medical Icons</div>
    <div className="card-block">
      <div className="row text-center">

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-ambulance fa-lg mt-4"></i><br/>ambulance
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-h-square fa-lg mt-4"></i><br/>h-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-heart fa-lg mt-4"></i><br/>heart
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-heart-o fa-lg mt-4"></i><br/>heart-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-heartbeat fa-lg mt-4"></i><br/>heartbeat
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-hospital-o fa-lg mt-4"></i><br/>hospital-o
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-medkit fa-lg mt-4"></i><br/>medkit
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-plus-square fa-lg mt-4"></i><br/>plus-square
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-stethoscope fa-lg mt-4"></i><br/>stethoscope
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-user-md fa-lg mt-4"></i><br/>user-md
        </div>

        <div className="col-6 col-sm-4 col-md-3 col-lg-2">
          <i className="fa fa-wheelchair fa-lg mt-4"></i><br/>wheelchair
        </div>

      </div>
    </div>
  </div>
</div>

    )
  }
}

export default FontAwesome;
